<script lang="ts">
    import { triggerClickOnEnterOrSpace } from "../../Utils/svelte-a11y";
    import XIcon from "../Icons/XIcon.svelte";
    import type { CoWebsite } from "../../WebRtc/CoWebsite/CoWebsite";
    import LoaderIcon from "../Icons/LoaderIcon.svelte";
    import { analyticsClient } from "../../Administration/AnalyticsClient";

    interface Props {
        coWebsite: CoWebsite;
        isLoading?: boolean;
        active?: boolean;
        onclick?: () => void;
        onclose?: () => void;
    }

    let { coWebsite, isLoading = false, active = false, onclick, onclose }: Props = $props();

    function closeTab() {
        onclose?.();
        analyticsClient.closeCowebsite();
    }

    function select() {
        onclick?.();
        analyticsClient.trackAdminEvent("cowebsite.switched");
    }
</script>

<div
    class="text h-full flex items-center pe-2 rounded-t-lg transition-all hover:stroke-white {active /* border border-b-0 border-solid border-transparent */
        ? ' bg-white hover:bg-white/90 tab justify-between bg-contrast/80' // translate-y-2 rounded-b-none for animation but not working inside dropdown
        : 'cursor-pointer bg-white/10 hover:bg-white/20 tab'}"
    role="button"
    tabindex="0"
    onclick={select}
    onkeydown={triggerClickOnEnterOrSpace}
>
    {#if !isLoading}
        <img draggable="false" src={coWebsite.getIcon()} alt="" class="ms-2 h-5 w-5 bg-black rounded-lg align-middle" />
    {:else}
        <div class="h-5 w-5 animate-pulse rounded-sm ms-2 {active ? 'bg-contrast/10' : 'bg-white/20'}">
            <LoaderIcon
                size="24"
                color1={active ? "stroke-contrast" : "stroke-white"}
                color2={active ? "stroke-contrast" : "stroke-white"}
            />
        </div>
    {/if}

    <div class="flex justify-around items-center w-full">
        <div class="py-2.5 ps-1 grow text-ellipsis overflow-hidden text-mdark">
            <div
                class="font-medium text-[12px] leading-3 text-ellipsis pb-1 pt-1 w-[80px] whitespace-nowrap overflow-hidden truncate {active
                    ? 'fill-white'
                    : ''}"
                title={coWebsite.getTitle()}
            >
                {#if !isLoading}
                    {coWebsite.getTitle()}
                {:else}
                    <div
                        class="w-[100px] h-2 animate-pulse rounded-sm {active ? 'bg-contrast/10' : 'bg-white/20'}"
                    ></div>
                {/if}
            </div>
        </div>

        <div class="flex gap-0.5">
            {#if coWebsite.isClosable() === true}
                <button
                    class="group hover:bg-contrast/10 transition-all aspect-ratio h-5 w-5 rounded flex items-center justify-center p-0"
                    onclick={(event) => {
                        event.stopPropagation();
                        closeTab();
                    }}
                    data-testid="close-cowebsite"
                    aria-label="Закрыть вкладку"
                >
                    <XIcon height="h-3" width="w-3" strokeColor="stroke-contrast" hover={active ? "" : ""} />
                </button>
            {/if}
        </div>
    </div>
</div>

<style>
    /* .tab {
        width: 300px;
    } */

    @media (max-width: 768px) {
        .tab {
            width: 220px;
            padding-right: 1.5rem;
        }
    }
</style>
